module.exports = __webpack_public_path__ + "img/IMG_2776.5cb9057a.jpg";